import {
  CheckCircleFilled,
  CheckCircleOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons';
import React from 'react';

/** Shared with entities table Capture WIP column and Transactions file-state stepper. */
export const CAPTURE_WORKFLOW_ICON_COLORS = {
  pendingReview: '#dba800',
  readyToPost: '#41aaaf',
  posted: '#3c7edb',
} as const;

export const CaptureWorkflowPendingReviewIcon: React.FC = () => (
  <ClockCircleOutlined
    className="entity-capture-backlog__icon entity-capture-backlog__icon--pending-review capture-workflow-metric__icon capture-workflow-metric__icon--pending-review"
    aria-hidden
  />
);

export const CaptureWorkflowReadyToPostIcon: React.FC = () => (
  <CheckCircleOutlined
    className="entity-capture-backlog__icon entity-capture-backlog__icon--ready-to-post capture-workflow-metric__icon capture-workflow-metric__icon--ready-to-post"
    aria-hidden
  />
);

export const CaptureWorkflowPostedIcon: React.FC = () => (
  <CheckCircleFilled
    className="capture-workflow-metric__icon capture-workflow-metric__icon--posted"
    aria-hidden
  />
);
